import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ICON_CALENDAR_CHECK, ICON_CALENDAR_DAY, ICON_CALENDAR_WEEK, ICON_REVOKE } from '../../../extras/icons';
import { APROBADA } from '../../../../data/audienceStates';
import RevokeForm from '../treatment/forms/RevokeForm';
import { C_RED } from '../../../extras/colors';
import Swal from 'sweetalert2';
import ManualForm from './ManualForm';
import AssistedForm from './AssistedForm';
import OptionsList from '../scheduling/OptionsList';
import AuthoritiesService from '../../../../services/AuthoritiesService';
import { AUDIENCIAS_AGENDAR, SOLICITUDES_REVOCAR } from '../../../../data/objects';
import FixedForm from './FixedForm';

//Función principal
const SchedulingActions = props => {
    //Tomo los props
    const { audience } = props;
    //Traigo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state
    const [showRevoke, setShowRevoke] = useState(false);
    const [showManual, setShowManual] = useState(false);
    const [showFixed, setShowFixed] = useState(false);
    const [showAssisted, setShowAssisted] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const [options, setOptions] = useState([]);
    const [judges, setJudges] = useState([]);
    const [backdropAF, setBackdropAF] = useState(false);
    //Función para Rechazar
    const handleRevoke = () => {
        Swal.fire({
            title: 'Revocar Audiencia',
            text: 'La operación de revocación de audiencia no podrá revertirse',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: C_RED,
            confirmButtonText: 'Si, Revocar'
        }).then((result) => {
            if(result.value){
                setTimeout(() => {
                    handleOpenRevoke();
                }, 300);
            }
        })
    }

    //Función para Asistido
    const handleAssisted = () => {
        handleOpenAssisted();
    }
    //Función para abrir asistido
    const handleOpenAssisted = () => {
        setShowAssisted(true);
    }
    //Función para cerrar asistido
    const handleCloseAssisted = () => {
        setShowAssisted(false);
    }

    //Función para abrir rechazo
    const handleOpenRevoke = () => {
        setShowRevoke(true);
    }

    //Función para cerrar rechazo
    const handleCloseRevoke = () => {
        setShowRevoke(false);
    }

    //Función para apertura
    const handleOpenManual = () => {
        setShowManual(true);
    }
    //Función para cierr
    const handleCloseManual = () => {
        setShowManual(false);
    }

    //Función para abrirr opciones
    const handleOpenOptions = () => {
        //Agrego backdrop
        setBackdropAF(true);
        //Muestro opciones
        setShowOptions(true);
    }

    //Función para cerrar opeciones
    const handleCloseOptions = () => {
        //Oculto ventana
        setShowOptions(false);
        //Quito backdrop
        setBackdropAF(false);
        //Limpio datos
        setOptions([]);
    }

    //Función para Fijo
    const handleOpenFixed = () => {
        setShowFixed(true);
    }
    //Función para abrir fijo
    const handleCloseFixed = () => {
        setShowFixed(false);
    }
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">AGENDAMIENTO</h6>
                </div>
                <div className="card-body">
                    <div className="row">
                        {
                            audience.estado.id === APROBADA ? (
                                <React.Fragment>
                                    {
                                        authorities && AuthoritiesService.hasPermission(authorities, AUDIENCIAS_AGENDAR) ? (
                                            <div className="col-md-3 mb-2">
                                                <Button variant="success" block onClick={handleAssisted}>
                                                    <ICON_CALENDAR_CHECK /> AGENDAMIENTO ASISTIDO
                                                </Button>

                                                <AssistedForm
                                                    show={showAssisted}
                                                    handleClose={handleCloseAssisted}
                                                    audience={audience}
                                                    setOptions={setOptions}
                                                    setJudges={setJudges}
                                                    handleOptions={handleOpenOptions}
                                                    hide={backdropAF}
                                                />

                                                <OptionsList
                                                    show={showOptions}
                                                    handleClose={handleCloseOptions}
                                                    audience={audience}
                                                    options={options}
                                                    judges={judges}
                                                />
                                            </div>
                                        ) : null
                                    }

                                    {
                                        authorities && AuthoritiesService.hasPermission(authorities, AUDIENCIAS_AGENDAR) ? (
                                            <div className="col-md-3 mb-2">
                                                <Button variant="primary" block onClick={handleOpenManual}>
                                                    <ICON_CALENDAR_DAY /> AGENDAMIENTO MANUAL
                                                </Button>

                                                <ManualForm
                                                    show={showManual}
                                                    handleClose={handleCloseManual}
                                                    audience={audience}
                                                />
                                            </div>
                                        ) : null
                                    }

{
                                        authorities && AuthoritiesService.hasPermission(authorities, AUDIENCIAS_AGENDAR) ? (
                                            <div className="col-md-3 mb-2">
                                                <Button variant="info" block onClick={handleOpenFixed}>
                                                    <ICON_CALENDAR_WEEK /> AGENDAMIENTO FIJO
                                                </Button>

                                                <FixedForm
                                                    show={showFixed}
                                                    handleClose={handleCloseFixed}
                                                    audience={audience}
                                                />
                                            </div>
                                        ) : null
                                    }
                                    
                                    {
                                        authorities && AuthoritiesService.hasPermission(authorities, SOLICITUDES_REVOCAR) ? (
                                            <div className="col-md-3 mb-2">
                                                <Button variant="danger" block onClick={handleRevoke}>
                                                    <ICON_REVOKE /> REVOCAR SOLICITUD
                                                </Button>

                                                <RevokeForm
                                                    show={showRevoke}
                                                    handleClose={handleCloseRevoke}
                                                    audience={audience}
                                                />
                                            </div>       
                                        ) : null
                                    }
                                    
                                </React.Fragment>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SchedulingActions;